import { render, staticRenderFns } from "./ClaimDateQuestion.vue?vue&type=template&id=0f1c3196&scoped=true"
import script from "./ClaimDateQuestion.vue?vue&type=script&lang=ts"
export * from "./ClaimDateQuestion.vue?vue&type=script&lang=ts"
import style0 from "./ClaimDateQuestion.vue?vue&type=style&index=0&id=0f1c3196&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1c3196",
  null
  
)

export default component.exports